<template>
    <Card pageTitle="Stock Transfers">
        <div>
            <div class="d-flex justify-content-between">
                <strong>Data Entries</strong>
                <div class="d-flex" style="gap: 10px">
                    <!-- <AllowPermission :permission="PERMISSION_CODES.CMS_DELETE_TRANSFER">
                        <Button noMargin @click="flushTransfers">{{
                            flushing ? "Please wait..." : "Clear Transfers"
                        }}</Button>
                    </AllowPermission> -->
                    <AllowPermission :permission="PERMISSION_CODES.CMS_CREATE_TRANSFER">
                        <router-link to="/stock-transfers/new">
                            <Button noMargin>New Transfer</Button>
                        </router-link>
                    </AllowPermission>
                </div>
            </div>
            
            <!-- Tab Navigation -->
            <div class="my-3" style="margin-bottom: calc(#{$sectionGap});">
                <TabContainer 
                    @change="handleTabChange" 
                    :tabs="Object.values(TRANSFER_TABS)" 
                    :selectedTab="selectedTab" 
                />
            </div>
            
            <AllowPermission :permission="PERMISSION_CODES.CMS_VIEW_TRANSFER">
                <div>
                    <CustomTable>
                        <template #head>
                            <tr>
                                <!-- todo: work on warehouse from and to names -->
                                <th>Status</th>
                                <th>Transfer #</th>
                                <th>Transfer From</th>
                                <th>Transfer To</th>
                                <th>Created By</th>
                                <th>Received By</th>
                                <th>Last Modified</th>
                            </tr>
                        </template>
                        <template #body>
                            <tr v-for="stockTransfer of stockTransfers" :key="stockTransfer.id">
                                <td>
                                    {{ stockTransfer.stock_transfer_status }}
                                </td>
                                <td>
                                    <router-link class="text-primary" :to="`/stock-transfers/${stockTransfer.id}`">
                                        {{ stockTransfer.name }}
                                    </router-link>
                                </td>
                                <td>
                                    {{ getWarehouseNameFromId(stockTransfer.from_warehouse_id, warehouses) }}
                                </td>
                                <td>
                                    {{ getWarehouseNameFromId(stockTransfer.to_warehouse_id, warehouses) }}
                                </td>
                                <td>
                                    {{ stockTransfer.created_by_user_name || '-' }}
                                </td>
                                <td>
                                    {{ stockTransfer.received_by_user_name || '-' }}
                                </td>
                                <td>
                                    {{ stockTransfer.updatedAtFormattedDateOnly }}
                                </td>
                            </tr>
                        </template>
                    </CustomTable>
                    <div v-if="loading" class="text-center my-3">Loading...</div>
                    <div v-else-if="!stockTransfers.length" class="text-center my-3">
                        {{ selectedTab.name === TRANSFER_TABS.ACTIVE.name ? 'No Active Transfers' : 'No Completed Transfers' }}
                    </div>
                </div>
            </AllowPermission>
            <Paginator :totalPages="totalPages" :page="page" @change="page = $event" />
        </div>
    </Card>
</template>

<script>
import CustomTable from "@/components/layout/CustomTable.vue"
import Paginator from "@/components/other/Paginator.vue"
import Button from "@/components/UI/Button.vue"
import TabContainer from "@/components/UI/TabContainer.vue"
import { usDateFormat } from "@/utils/common"
import { getWarehouseNameFromId } from "@/utils/inventory"

import { http } from "@/utils/http"
import { mapState } from "vuex"
import Card from "../../../components/UI/Card.vue"
import AllowPermission from "../../../components/layout/AllowPermission.vue"
import { PERMISSION_CODES } from "../../../store/permission"

const TRANSFER_TABS = {
    ACTIVE: {
        name: "ACTIVE",
        value: "Active Transfers"
    },
    COMPLETED: {
        name: "COMPLETED", 
        value: "Completed Transfers"
    }
}

export default {
    components: { AllowPermission, Card, Button, Paginator, CustomTable, TabContainer },
    data() {
        return {
            flushing: false,
            page: 1,
            limit: 20,
            totalPages: 0,
            loading: false,
            stockTransfers: [],
            PERMISSION_CODES,
            TRANSFER_TABS,
            selectedTab: TRANSFER_TABS.ACTIVE
        }
    },
    mounted() {
        this.fetchTransfers()
    },
    computed: {
        ...mapState("misc", ["warehouses", "transferStatuses"]),
        statusFilter() {
            if (this.selectedTab.name === this.TRANSFER_TABS.ACTIVE.name) {
                return [this.transferStatuses.PENDING, this.transferStatuses.SHIPPED, this.transferStatuses.TRANSFERRED]
            } else {
                return [this.transferStatuses.COMPLETED]
            }
        }
    },
    methods: {
        usDateFormat,
        getWarehouseNameFromId,
        handleTabChange(tab) {
            this.selectedTab = tab
            this.page = 1 // Reset to first page when changing tabs
            this.fetchTransfers()
        },
        async flushTransfers() {
            this.flushing = true
            try {
                await http.delete(`/stock-transfers/flush`)
                this.stockTransfers = []
            } catch (err) {
                console.log("error in flushing items", err)
            }
            this.flushing = false
        },
        async fetchTransfers() {
            this.loading = true
            try {
                const statusParams = this.statusFilter.map(status => `stock_transfer_statuses=${status}`).join('&')
                const res = await http.get(`/stock-transfers?page=${this.page}&limit=${this.limit}&${statusParams}`)
                this.stockTransfers = res.data.result
                this.totalPages = res.data.totalPages
            } catch (err) {
                console.log("error in loading items", err)
            }
            this.loading = false
        },
    },
    watch: {
        page() {
            this.fetchTransfers()
        },
    },
}
</script>

<style></style>
